import api from "./api";
const endpoint = "/volontariat/CVAutreCompetence";
export const CVAutreCompetenceService = {
  async insert(data) {
    try {
      const result = await api.post(endpoint + "/create", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(data) {
    try {
      const result = await api.put(endpoint + "/update", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(data) {
    try {
      const result = await api.post(endpoint + "/delete", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(data) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: data,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_by_id(id) {
    try {
      const result = await api.get(endpoint + "/find_by_id", {
        params: { id_autre_competence: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async liste(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
